/** @format */

import OrdersCreatePage from './OrdersCreatePage';
export default OrdersCreatePage;
